export default "__VITE_ASSET__613e2c42__"